const config = {
  backupandtest: 'Backup and Test',
  day: 'Day of the week',
  createbackup: 'Create Backup',
  testbackup: 'Test Backup',
  alwaysuse: 'Always use the default Backup Time setting',
  settings: 'Settings',
  reportsettings: 'Report-Settings',
  standardprofile: 'Standard Profile for Backups',
  backuptime: 'Default Backup Time',
  time: 'Time',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  save: 'Save',
  cancel: 'Cancel',
  report: 'Reporting',
  email: 'E-Mail',
  contactperson: 'Contact Person',
  sendreport: 'Send Monthly Report to Customer',
  nobackuptool: '<h4>Error detecting Backup-Tool</h4><p>No supported backup tools are detected on your site. <br/><br/> Please install <strong>Akeeba Backup Pro</strong> to create Remote-Backups.<br/>No worries, we support you with a <a href="/#/toolbox">30% discount on your Pro subscription</a></p>',
  reportintro: '<p>Make your work transparent to your customer by sending customized monthly reports.<br/>Upload your logo and edit the colour-scheme to customize your reports using our <a href="/#/settings">report customizer</a>.</p>',
  schedule: 'Schedule',
  sendcopy: 'Send Monthly Report to Myself',
  autobackup: '',
  autobackupintro: 'Always create a backup of the website before processing automated extension updates.',
  settingsautobackup: 'Automated Extension Updates',
  settingsmonitoring: 'Monitoring',
  downtimetolerance: 'Downtime notification waiting time',
  settingsbackendlink: 'Backend Link',
  backendlink: 'Backend Link',
  globalsetting: 'Global',
  globalautoupdateon: 'Global On',
  globalautoupdateoff: 'Global Off',
  autoupdateon: 'Autoupdate On',
  autoupdateoff: 'Autoupdate Off',
  backupprofile: 'Backup-Profile',
  alwaysuseprofile: 'Always use the default Backup Profile'
}

export default config
